import { useState } from 'react';

export function useTableRowDnD(items, setItems) {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);

  const reorder = (from, to) => {
    if (from === to) return;
    const updated = [...items];
    const [removed] = updated.splice(from, 1);
    updated.splice(to, 0, removed);
    setItems(updated);
  };

  const getRowProps = idx => ({
    onDragStart: e => {
      setDraggedIndex(idx);
      e.dataTransfer.effectAllowed = 'move';
    },
    onDragOver: e => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      setOverIndex(idx);
    },
    onDrop: () => {
      if (draggedIndex !== null && draggedIndex !== idx) reorder(draggedIndex, idx);
      setDraggedIndex(null);
      setOverIndex(null);
    },
    onDragEnd: _e => {
      setDraggedIndex(null);
      setOverIndex(null);
    },
  });

  return { draggedIndex, overIndex, getRowProps };
}
